import main from './main.vue'
const commonButton= {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonButton